export const PAYMENT_METHODS_TEST_IDS = {
  paymentMethods: 'paymentMethods',
  creditCard: 'creditCard',
  ach: 'ach',
};
